import { render, staticRenderFns } from "./job.vue?vue&type=template&id=aa704b5e&scoped=true&"
import script from "./job.vue?vue&type=script&lang=js&"
export * from "./job.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa704b5e",
  null
  
)

export default component.exports